<template>
  <div>
    <v-row>
      <v-col cols="6" class="pt-2 pb-0 mb-n4">
      <CommonDropDowns class="pt-1" :isCommentsCategoryDisabled="true"
        :isItCategory=true @change="dataFromCommonDropDowns"
        :commentsCategoryValue="editedItem.category" />
      </v-col>
      <v-col cols="6" class="pt-2 pb-0 mb-n4">
        <v-autocomplete :items="reasonListDropDown" class="input-text-size" label='Reason Code'
         v-model="editedItem.reasonCode" item-text="name" item-value="value" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" class="pt-2 pb-0">
        <v-checkbox v-model="editedItem.addToLegal" class="input-text-size"
          label="Add To Legal on Statement" />
      </v-col>
      <v-col cols="4" class="pl-3 pa-0 mt-2">
        <v-checkbox class="input-text-size" v-model="editedItem.sendToWebsite"
        label="Send To Website" />
      </v-col>
      <v-col cols="4" class="pl-3 pa-0 mt-2">
        <v-checkbox class="input-text-size" v-model="editedItem.rollToNextYear"
          label="Roll To Next Year" />
      </v-col>
      <v-col cols="12">
        <v-textarea
         class="input-text-size pa-0 mb-n5"
        outlined rows="3"
        v-model="editedItem.comment"
        v-textAreaUppercase=globalSettingItem.conEverythingToCaps
        >
          <template v-slot:label>
            <label>Comments</label>
          </template>
        </v-textarea>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import CommonDropDowns from '../../common-utils/CommonDropDowns.mixin.vue';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'AddCommentDialog',
  mixins: [GlobalToCaps],
  components: {
    CommonDropDowns,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'pickListAddCommentsDialogs',
    },
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'items', 'index', 'isVisible']),
    ...mapState({
      taxYearList: (state) => state.tax.taxCommon.taxYearList,
      commentsCategory: (state) => state.tax.taxComments.commentsCategory,
      reasonListDropDown: (state) => state.base.crud.items.reasonListDropDown,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
    dataFromCommonDropDowns(val, whichField) {
      this.editedItem[whichField] = val;
    },
  },
};
</script>
